'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Typography, Container, Grid } from '@mui/material';
import { Card, CardHeader, CardBody, CardFooter } from "@heroui/react";
import Link from 'next/link';
import Image from "next/image";


export const TeamSection = ({ data }) => {
    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        Team
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="full" className="no-padding">
                    <Grid container spacing={2}>
                        {data.map((item, index) => {
                            const imageUrl = item.bild;
                            return (
                                <Grid key={index} container item xs={12} sm={6} md={4} lg={3} xl={3} className="no-padding-x">
                                    <Card shadow="sm" className="py-4">
                                        <CardHeader>
                                            <Image
                                                alt={item.name}
                                                src={imageUrl}
                                                width={500}
                                                height={300}
                                                style={{ objectFit: 'cover' }}
                                                loading="lazy"
                                            />
                                        </CardHeader>
                                        <CardBody className="pb-0 pt-2 px-4 flex-col items-start">
                                            <Typography variant="h4" component="h2" gutterBottom>
                                                {item.name}
                                            </Typography>
                                            <Typography variant="body2">
                                                {item.jobbezeichnung}
                                            </Typography>
                                        </CardBody>
                                        <CardFooter className="overflow-visible px-4 py-4">
                                            <Grid container>
                                                <Grid item xs={12} >
                                                    <Link href={`mailto:${item.email}`} className="text-default-500">{item.email}</Link>
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <Link href={`tel:${item.telefon}`} className="text-default-500">{item.telefon}</Link>
                                                </Grid>
                                            </Grid>
                                        </CardFooter>
                                    </Card>
                                </Grid>
                            )
                        }
                        )
                        }
                    </Grid>
                </Container>
            </div>
        </motion.section>
    );
};
